/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportListConnectionsQueryResponse, SocialExportListConnectionsQueryParams, SocialExportListConnections400, SocialExportListConnections401, SocialExportListConnections403 } from "../models/SocialExportListConnections";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportListConnections } from "../axios/socialExportListConnections";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportListConnectionsQueryKey = (params: SocialExportListConnectionsQueryParams = {}) => ["api-v2", { url: '/social-export/v1/connections' }, ...(params ? [params] : [])] as const

export type SocialExportListConnectionsQueryKey = ReturnType<typeof socialExportListConnectionsQueryKey>

export function socialExportListConnectionsQueryOptions(params?: SocialExportListConnectionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportListConnectionsQueryKey(params)
        return queryOptions<SocialExportListConnectionsQueryResponse, ResponseErrorConfig<SocialExportListConnections400 | SocialExportListConnections401 | SocialExportListConnections403>, SocialExportListConnectionsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportListConnections(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns every social platform connection belonging to the authenticated client, with connection state, profile info, and linked station IDs. Optionally filter by platform.
 * @summary List all connection states for the client
 * {@link /social-export/v1/connections}
 */
export function useSocialExportListConnections<TData = SocialExportListConnectionsQueryResponse, TQueryData = SocialExportListConnectionsQueryResponse, TQueryKey extends QueryKey = SocialExportListConnectionsQueryKey>(params?: SocialExportListConnectionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SocialExportListConnectionsQueryResponse, ResponseErrorConfig<SocialExportListConnections400 | SocialExportListConnections401 | SocialExportListConnections403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportListConnectionsQueryKey(params)
         

         const query = useQuery({
          ...socialExportListConnectionsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportListConnections400 | SocialExportListConnections401 | SocialExportListConnections403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}